/**
 * To prevent absolute URLs typed incorrectly by the CMS user
 * from acting as relative URLs
 */
export const prependHttpsIfProtocolNotPresent = (url: string): string => {
  if (!url.startsWith('http')) {
    return `https://${url}`;
  }
  return url;
};
